@if (loadingSpinnerService.isSpinnerVisible()) {
  <vwui-spinner class="vwui-spinner--with-margin"></vwui-spinner>
}

@if (!quickscanSubmitted()) {
  <div class="main-wrapper">
    @if (!mandateDetails?.preconditions?.quickscanNotFilledIn.satisfiedOrOptional) {
      <app-explanation [link]="getUriForStep(2)">{{ 'COMPONENT.mandating.cannot_start.quickscan_not_filled' | translate }}</app-explanation>
    }
    @if (!mandateDetails?.preconditions?.quickscanNotSubmitted.satisfiedOrOptional) {
      <app-explanation [link]="getUriForStep(2)">{{ 'COMPONENT.mandating.cannot_start.project_not_classified' | translate }}</app-explanation>
    }
  </div>
}

@if (!loadingSpinnerService.isSpinnerVisible()) {
  <div>
    <div class="project-analysis">
      <vwui-header>
        @if (isQuickScan()) {
           {{ 'PAGE_FILL_QUICKSCAN.title' | translate }}
        } @else {
           {{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.title' | translate }}
        }
        @if (projectVersionLabel) {
          <small class="header-subtitle">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.project_version' | translate }}: {{ projectVersionLabel }}</small>
        }
        <small class="header-subtitle">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.version' | translate }}: {{ tisDefinition?.versionId }}</small>
        <small class="header-subtitle">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.project_id' | translate }}: {{ projectDetails.id }}</small>
      </vwui-header>
      <div class="label spacing-mb" [class.text-warning]="hasEmptyRequiredQuestion() && isPreviousUrlMandating">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.required_fields' | translate }}</div>
        @for (selectedCategory of visibleCategories(); track selectedCategory.id; let categoryIndex = $index) {
        <div class="category-block" id="category_{{ selectedCategory.id }}" #categoryBlock>
          <vwui-table [compactable]="false">
            <div slot="table-title">{{ categoryIndex + 1 }}. {{ selectedCategory.name }}</div>
            <vwui-table-row>
              <vwui-table-header
              class="question-col question-col--question">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.table.column.question' | translate }}</vwui-table-header>
              <vwui-table-header
              class="question-col question-col--answer">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.table.column.answer' | translate }}</vwui-table-header>
            </vwui-table-row>
            @for (question of selectedCategory.questions; track question; let questionIndex = $index) {
              @if (showQuestion(question)) {
                  @if (isDependencyMet(question)) {
                      <vwui-table-row [ngClass]="{'question-col question-col--with-attachments': question.allowAttachments}">
                          <vwui-table-column class="question-col question-col--question">
                              <span [class.question--required]="!question.isOptionalOrCalculated">{{ categoryIndex + 1 }}.{{ questionIndex + 1 }} {{ question.title || question.name }}</span>
                              @if (question.question && question.question !== question.title && question.question !== question.name) {
                                  <div class="question-text">{{ question.question }}</div>
                              }
                              @if (question.info) {
                                  <vwui-tooltip [label]="question.info">
                                      <vwui-icon class="info" iconName="info"></vwui-icon>
                                  </vwui-tooltip>
                              }
                          </vwui-table-column>
                          <vwui-table-column class="question-col question-col--answer">
                              <app-question-input
                                  [question]="question"
                                  [ngModel]="getInitialValue(question)"
                                  (valueChanged)="answerChanged($event, question)"
                                  [readonly]="isReadOnly()"
                                  [departments]="departments"
                              >
                              </app-question-input>
                              @if (showExplanationField(question)) {
                                  <vwui-textarea
                                      autosize
                                      class="vwui-textarea--table-column question-explanation"
                                      [placeholder]="'COMPONENT.quickscan_list.explanation' | translate"
                                      (vwuiChange)="explanationChanged($event.detail.value, question)"
                                      [value]="getExplanation(question)"
                                      [disabled]="isReadOnly()"
                                  ></vwui-textarea>
                              }
                          </vwui-table-column>
                      </vwui-table-row>
                      @if (question.allowAttachments) {
                          <vwui-table-row class="question-col question-col--attachments">
                              <vwui-table-column class="question-col question-col--attachments-label">
                                  {{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.table.column.attachments' | translate }}
                              </vwui-table-column>
                              <vwui-table-column class="question-col question-col--attachments-list">
                                  <app-question-attachments
                                      [question]="question"
                                      [attachments]="getQuestionAttachments(question)"
                                      (valueChanged)="attachmentsChanged($event, question)"
                                      [readonly]="isReadOnly()"
                                  >
                                  </app-question-attachments>
                              </vwui-table-column>
                          </vwui-table-row>
                      }
                  }
              }
            }
          </vwui-table>
        </div>
      }
    </div>
  </div>
}
